<template>
  <billing-customer>

<div class="container-fluid">
    
    <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <div class="card box_custom search-box">
                <div class="countItems"><h4 class="page-title">Vendors</h4></div>
                <!-- <div class="countItems"><h3> 182</h3> <span>Total customer</span></div> -->
                <div class="btn-group d-flex justify-content-end actionTop" role="group" aria-label="Button group with nested dropdown ">
                  <div class="btn-group" role="group">
                      <button type="button" class="btn btn-success btn-new" @click="showformregister"><i class="fas fa-plus"></i></button>
    <div class="dropdown-menu dropdown-menu-right" style="width:184px" aria-labelledby="btnGroupDrop1" v-bind:class="{ show: ShowMenuDropCus }" v-show="ShowMenuDropPCus">
    </div>
              </div>
                            
                </div>
                <form class="app-search position-absolute" >
                    <input type="text" class="form-control" placeholder="Search Vendors" autofocus="autofocus"  v-model="TextSearchCustomer">
                    <a class="srh-btn">
                        <i class="fas fa-search"></i>
                    </a>
                </form>

<div class="comment-widgets srollclientes">
    <div class="card card-body" >
 <Loader v-if="isLoadingCustomers"></Loader>                
 <div class="list-group list-group-flush">
<div class="list-group-item list-group-item-action d-flex justify-content-between align-items-left" v-for="item in filteredCustomer" :key="item.id" @click="DetailVendors(item.id)">
    <div class="d-block">
          <span>{{item.company_name}} <span v-if="item.firstname !== null"> - {{item.firstname}} {{item.lastname}}</span></span>
      </div>
</div>
</div>
</div>
              
          
                    </div>
                </div>
      </div>
<div class="col-sm-12 col-md-6 col-lg-8 col-xl-9">
       <div class="card">
          <div class="content-default-customer" v-if="ShowDefaultContentCustomer">
                    <div class="card-header">
                    <h5 class="card-title">Vendors</h5>
                    </div>
                    <div class="card-body">
                        Tap on any "Customer name" to see details
                    </div>
                </div>
                
                <div class="content-form-register" v-show="registerForm">
            <form class="form-horizontal form-material" @submit.prevent="MetNewVendorsAdd">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6"><b style="font-size: 21px;font-weight: 100;">{{NewCustomer.titleactionForm}} Vendor</b></div>
                    <div class="col-md-6">
                    <div class="d-block text-right" style="width:100%">
                                     <input type="hidden" class="form-control" v-model="NewCustomer.id" name="idcustomer"> 
                               <button type="submit" class="btn btn-success btn-lg b-block BtnSave"><i class="fas fa-save"></i> Save</button> 
                                <button type="button" class="btn btn-light btn-lg b-block Btncancel" @click="MetCancelFormC" v-if="ShowBtncancel"><i class="fas fa-window-close"></i> Cancel</button>
                                <button type="button" class="btn btn-light btn-lg b-block Btncancel" @click="MetCancelFormC" v-else><i class="fas fa-window-close"></i> Cancel</button>
                               <button type="button" @click="MetDeleteCustomer(DetailVendorsItem.id)" v-if="ShowBtnDel" class="btn btn-danger btn-lg b-block BtnDel"><i class="fas fa-trash-alt"></i> Delete</button>
                                </div>  
                    </div> 
                  </div>  
                </div>
                
              <div class="card-body">
                  <div class="bgloading" v-if="isLoading">
                    <Loader></Loader>
                  </div>
                  
                    <div class="row">
                      <div class="col-md-12 col-lg-6">
                        <div class="row">
                          <div class="col-md-12 col-lg-12 col-xl-6">
                              <div class="form-group">
                              <label class="">Company Name</label>
                              <input type="text" v-model="NewCustomer.company_name" class="form-control" required>
                              </div>
                          </div>
                          <div class="col-md-12 col-lg-12 col-xl-6">
                              <div class="form-group">
                              <label class="">Title</label>
                               <select class="form-control" name="referal" v-model="NewCustomer.title">
                                <option value="0" selected> -- Select --</option>
                                <option value="Dr.">Dr.</option>
                                <option value="Miss.">Miss.</option>
                                <option value="Mr.">Mr.</option>
                                <option value="Mrs.">Mrs.</option>
                                <option value="Ms.">Ms.</option>
                                <option value="Prof.">Prof.</option>
    
                                </select>
                              </div>
                          </div>
                          <div class="col-md-6 col-lg-6">
                              <div class="form-group">
                              <label class="">First Name</label>
                              <input type="text"  v-model="NewCustomer.firstname" class="form-control">
                              </div>
                          </div>
                          <div class="col-md-6 col-lg-12 col-xl-6">
                              <div class="form-group">
                              <label class="">Middle Name</label>
                               <input type="text" name="bussinesname" v-model="NewCustomer.middletname" class="form-control">
                              </div>
                          </div>
                          <div class="col-md-12 col-lg-12 col-xl-12">
                              <div class="form-group">
                              <label class="">Last Name</label>
                             <input type="text" name="bussinesname" v-model="NewCustomer.lastname" class="form-control">
                              </div>
                          </div>
        <div class="col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
            <label class="">Display Name As</label>
            <select class="form-control" name="referal" v-model="NewCustomer.displayname">
             <option v-for="listValue in valuesListDisplayname" :key="listValue.id" 
                :selected="NewCustomer.displayname == listValue.id"
                :value="listValue.id">{{listValue.name}}</option>
              </select>
            </div>
        </div>
                         <div class="col-md-6 col-lg-12 col-xl-6">
                              <div class="form-group">
                              <label class="">Print on Check As</label>
                             <input type="text" name="bussinesname" v-model="NewCustomer.printoncheck" class="form-control">
                              </div>
                          </div>
                           <div class="col-md-6 col-lg-12 col-xl-6">
                              <div class="form-group">
                              <label class="">Status</label>
                             <select class="form-control" v-model="NewCustomer.status">
                                <option value="1" selected>Active</option>
                                <option value="0">Inactive</option>
    
                                </select>
                              </div>
                          </div>

                         </div>
                      </div>
                        <div class="col-md-12 col-lg-6 col-xl-6">
                         <div class="row">
                             <div class="col-md-12 col-lg-12">
                              <div class="form-group">
                              <label class="">Email</label>
                              <input type="text" class="form-control" v-model="NewCustomer.email" name="email">
                              </div>
                          </div>
    
                            <div class="col-md-12 col-lg-12 col-xl-6">
                                <div class="form-group">
                                <label class=""> Phone</label>
                                <input type="text" class="form-control" v-model="NewCustomer.phone" name="officephone">
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-6">
                                <div class="form-group">
                                <label class="">Mobile Phone</label>
                                <input type="text" class="form-control" v-model="NewCustomer.mobilephone" name="mobilephone">
                                </div>
                            </div>
 
                            <div class="col-md-12">
                              <div class="form-group">
                              <label class="">Fax</label>
                              <input type="text" class="form-control" v-model="NewCustomer.fax" name="">
                              </div>
                          </div>
                          <div class="col-md-12">
                              <div class="form-group">
                              <label class="">Other</label>
                              <input type="text" class="form-control" v-model="NewCustomer.other" name="">
                              </div>
                          </div>
                          <div class="col-md-12">
                              <div class="form-group">
                              <label class="">Website</label>
                              <input type="text" class="form-control" v-model="NewCustomer.website" name="website">
                              </div>
                          </div>
                         </div>
                        </div>
                      </div>
                      <br>
                     <div style="display:block; margin-bottom: 0px;"></div>
                  <div class="row">
                   <div class="col-md-12" style="background-color: #f1f1f1; padding-top:10px;">
                          <div class="row" >
                      <div class="col-md-12">
                              <div class="form-group">
                              <label class="">Address</label>
                              <input type="text" class="form-control" v-model="NewCustomer.adressinfo">
                              </div>
                          </div>
                            <div class="col-md-12 col-lg-12 col-xl-4">
                                <div class="form-group">
                                <label class="">City</label>
                                <input type="text" class="form-control" name="" v-model="NewCustomer.cityinfo">
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-4">
                                <div class="form-group">
                                <label class="">State</label>
                                <input type="text" class="form-control" name="" v-model="NewCustomer.stateinfo">
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-4">
                                <div class="form-group">
                                <label class="">Zip code</label>
                                <input type="text" class="form-control" name="" v-model="NewCustomer.zipcodeinfo">
                                </div>
                            </div>
                       </div>
                    </div>
                   
                    </div>
                  
              </div>
              </form>
              </div>
              <div class="content-detail-customer" v-if="detailcontent" >
                  <div class="bgloading" v-show="isLoading">
                    <Loader></Loader>
                  </div>
                  
                  <div class="card-body" v-if="DetailVendorsItem !== null">
                      <div class="row">
                          <div class="col-md-7">
                        <h3 class="card-title">{{DetailVendorsItem.company_name}} - {{DetailVendorsItem.firstname}} {{DetailVendorsItem.lastname}} <span class="badge badge-success" style="font-size:12px;">Active</span><button @click="MetEditVendors" class="btn btn-info btn-sm eboton"><i class="fas fa-pen"></i></button> </h3>
                        <h6 class="card-subtitle mb-2">Company Name: <b>{{DetailVendorsItem.company_name}}</b></h6>
                        <h6 class="mb-2">Phone: {{DetailVendorsItem.mobilephone}} | Cell: {{DetailVendorsItem.mobilephone}}</h6>
                        <h6>Email: {{DetailVendorsItem.email}}</h6>
                        <h6>Print on Check As {{DetailVendorsItem.printoncheck}}</h6>
                
                          </div>
                          <div class="col-md-5">
                            <div class="card">
                            <div class="card-body contenedor-total">
                               
                            </div>
                            </div>
                          </div>
                      </div>
                    
                </div>
              </div>
              
         </div>
      </div>
    </div>
</div>
<notifications group="noti" position="top center">
</notifications>
</billing-customer>
</template>
<script>
import axios from 'axios'
import ClickOutside from 'vue-click-outside'
import Loader from '@/components/shared/Loader'
import BillingCustomer from '@/Layouts/Billing/BillingLayout'

export default {
    name:'CustomerPage',
    components:{
        BillingCustomer,
        Loader
    },
    data() {
        return {
            isLoading: false,
            DetailVendorsItem : null,
            valuesListDisplayname: [
                {name: null, id: 1},
                {name: null, id: 2},
                {name: null, id: 3},
                {name: null, id: 4},
            ],
            ShowDefaultContentCustomer : true,
            isLoadingCustomers: false,
            MessageSuccefull : null,
            access_token : null,
            ShowMenuDropCus: false,
            registerForm : false,
            detailcontent : false,
            CustomersList: [],
            TextSearchCustomer : '',
            customerDetail : null,
            ShowBtnDel: false,
            ShowBtncancel: false,
            ActionType:'',
            NewCustomer: {
                id : null,
                titleactionForm : null,
                user_id : null,
                company_name : null,
                title : '',
                firstname: '',
                middletname: '',
                lastname : '',
                displayname : 1,
                printoncheck : null,
                status : 1,
                email : null,
                phone : null,
                mobilephone : null,
                fax : null,
                other : null,
                website : null,
                adressinfo : null,
                cityinfo : null,
                stateinfo : null,
                zipcodeinfo : null,
            },
            customerID: null,
        }
    },
    created(){
     this.getVendors();
    },
    mounted(){
    
    },
    directives: {
    ClickOutside
  },
    methods: {
   
        hide () {
        this.ShowMenuDropCus = false
        },

 

        getVendors()  {
              var self = this;
              this.isLoadingCustomers = true;
            window.billing.get('vendors/'+ window.localuserdata)
                .then((response) => {
                  if(response.data.success){
                     self.CustomersList = response.data.result;
                  }         
                   

					self.isLoadingCustomers = false;
                }).catch((error) => console.log(error));
        },
        DetailVendors(id){
          console.log(id);
          this.customerID = id;
           this.isLoading = true;
          this.ShowDefaultContentCustomer = false;
          this.detailcontent = true;
          this.registerForm = false;

          window.billing.get('vendors/'+ id +'/'+ window.localuserdata)
                .then((response) => {
                   this.isLoading = false;
                   this.detailcontent = true;
                  if(response.data.success){
                     this.DetailVendorsItem = response.data.result;
                  }         
					this.isLoadingCustomers = false;
                }).catch((error) => console.log(error));
        },
   
        ShowMenuDropPCus(){
            
            this.ShowMenuDropCus = true;

        },
        MetNewVendorsAdd(){
            
            this.ShowDefaultContentCustomer = false;
            this.isLoading = true;
            if(this.ActionType == 'new'){
               window.billing.post('vendors/add',{
                    user_id : window.localuserdata,
                    company_name : this.NewCustomer.company_name,
                    title : this.NewCustomer.title,
                    firstname : this.NewCustomer.firstname,
                    middletname : this.NewCustomer.middletname,
                    lastname : this.NewCustomer.lastname,
                    displayname : this.NewCustomer.displayname,
                    printoncheck : this.NewCustomer.printoncheck,
                    status : this.NewCustomer.status,
                    email : this.NewCustomer.email,
                    phone : this.NewCustomer.phone,
                    mobilephone : this.NewCustomer.mobilephone,
                    fax : this.NewCustomer.fax,
                    other : this.NewCustomer.other,
                    website : this.NewCustomer.website,
                    adressinfo : this.NewCustomer.adressinfo,
                    cityinfo : this.NewCustomer.cityinfo,
                    stateinfo : this.NewCustomer.stateinfo,
                    zipcodeinfo : this.NewCustomer.zipcodeinfo,
              }).then((response) => {
                 this.MessageSuccefull = response.data;
                 this.isLoading = false;
                  this.ShowDefaultContentCustomer = true;
                  this.detailcontent = false;
                  this.registerForm = false;
                 this.getVendors();
                 this.$notify({
                    group: 'noti',
                    title: 'Created',
                    type: 'success',
                    text: 'Created successfull',
                    }); 
               
                    this.clearForms();
                }).catch((error) => console.log(error,this.isLoading = false));
             }

            if(this.ActionType == 'update'){
                window.billing.put('vendors/edit/' + this.NewCustomer.id,{
                    user_id : window.localuserdata,
                    company_name : this.NewCustomer.company_name,
                    title : this.NewCustomer.title,
                    firstname : this.NewCustomer.firstname,
                    middletname : this.NewCustomer.middletname,
                    lastname : this.NewCustomer.lastname,
                    displayname : this.NewCustomer.displayname,
                    printoncheck : this.NewCustomer.printoncheck,
                    status : this.NewCustomer.status,
                    email : this.NewCustomer.email,
                    phone : this.NewCustomer.phone,
                    mobilephone : this.NewCustomer.mobilephone,
                    fax : this.NewCustomer.fax,
                    other : this.NewCustomer.other,
                    website : this.NewCustomer.website,
                    adressinfo : this.NewCustomer.adressinfo,
                    cityinfo : this.NewCustomer.cityinfo,
                    stateinfo : this.NewCustomer.stateinfo,
                    zipcodeinfo : this.NewCustomer.zipcodeinfo,
              }).then((response) => {
                 this.isLoading = false;
                  
                  this.detailcontent = true;
                  this.registerForm = false;
                 this.getVendors();
                   this.$notify({
                    group: 'noti',
                    title: 'Updated Ok',
                    type: 'success',
                    text: 'Updated successfull',
                    }); 
              
                    this.ShowDefaultContentCustomer = false;
                }).catch((error) => console.log(error,this.isLoading = false));

               
            }

        },
        MetEditVendors(){
          console.log('edit form');
            this.ActionType = 'update'
            this.NewCustomer.titleactionForm = 'Edit'
            this.NewCustomer.id = this.DetailVendorsItem.id
            this.NewCustomer.user_id = this.DetailVendorsItem.user_id
            this.NewCustomer.company_name = this.DetailVendorsItem.company_name
            this.NewCustomer.title = this.DetailVendorsItem.title
            this.NewCustomer.firstname = this.DetailVendorsItem.firstname
            this.NewCustomer.middletname = this.DetailVendorsItem.middletname
            this.NewCustomer.lastname = this.DetailVendorsItem.lastname
            this.NewCustomer.displayname = this.DetailVendorsItem.displayname
            this.NewCustomer.printoncheck = this.DetailVendorsItem.printoncheck
            this.NewCustomer.status = this.DetailVendorsItem.status
            this.NewCustomer.email = this.DetailVendorsItem.email
            this.NewCustomer.phone = this.DetailVendorsItem.phone
            this.NewCustomer.mobilephone = this.DetailVendorsItem.mobilephone
            this.NewCustomer.fax = this.DetailVendorsItem.fax
            this.NewCustomer.other = this.DetailVendorsItem.other
            this.NewCustomer.website = this.DetailVendorsItem.website
            this.NewCustomer.adressinfo = this.DetailVendorsItem.adressinfo
            this.NewCustomer.cityinfo = this.DetailVendorsItem.cityinfo
            this.NewCustomer.stateinfo = this.DetailVendorsItem.stateinfo
            this.NewCustomer.zipcodeinfo = this.DetailVendorsItem.zipcodeinfo
   
          this.ShowDefaultContentCustomer = false;
          this.detailcontent = false;
          this.registerForm = true;
          this.ShowBtnDel= true;
          this.ShowBtncancel= true;
        },
        MetDeleteCustomer(id){
         console.log(id);
         window.billing.delete('customer/'+ id)
                .then((response) => {
                     console.log(response.data.success);
                     if(response.data.success){
                       console.log('deeted');
                       this.getCustomers();
                       this.$notify({
                          group: 'noti',
                          title: 'Deleted',
                          type: 'success',
                          text: 'Deleted successfull',
                          }); 

                    
                     }else{
                        this.$notify({
                          group: 'noti',
                          title: 'Error',
                          type: 'error',
                          text: 'This customer have attached documents and can not be deleted',
                          }); 
                     
                     }
                   this.MetCancelFormC();
                     
                }).catch(function (error) {
              console.log(error);
            });
        },
        MetCancelFormC(){

         this.ShowDefaultContentCustomer = false;
         this.registerForm = false;
         this.detailcontent = true;
        },

        showformregister(){
          this.ActionType = 'new';
          this.NewCustomer.titleactionForm = 'New';
          this.ShowDefaultContentCustomer = false;
          this.detailcontent = false;
          this.registerForm = true;
          this.ShowBtnDel= false;
          this.ShowBtncancel= false;
          this.clearForms();
      },
      clearForms(){
          this.NewCustomer = {
                id : null,
                titleactionForm : null,
                user_id : null,
                company_name : null,
                title : '',
                firstname: '',
                middletname: '',
                lastname : '',
                displayname : 1,
                printoncheck : null,
                status : 1,
                email : null,
                phone : null,
                mobilephone : null,
                fax : null,
                other : null,
                website : null,
                adressinfo : null,
                cityinfo : null,
                stateinfo : null,
                zipcodeinfo : null,
          }
      },
   
     
    },
    beforeMount(){
        
    },
    computed:{
       filteredCustomer: function () {
            var self = this;
            return this.CustomersList.filter(function (item) {
                return item.firstname && item.firstname.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0
                || item.company_name && item.company_name.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0
                || item.lastname && item.lastname.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0;
            });
        } 
    },
    watch: {
       'NewCustomer.company_name': function (val) {
        this.NewCustomer.printoncheck = val
        this.valuesListDisplayname[0].name = val
      },
      'NewCustomer.title': function (val) {
        this.valuesListDisplayname[0].name = this.NewCustomer.company_name + ' ' + val
      },
      'NewCustomer.firstname': function (val) {
        this.valuesListDisplayname[0].name = this.NewCustomer.company_name + ' ' + this.NewCustomer.title + ' ' + val
      },
      'NewCustomer.middletname': function (val) {
        this.valuesListDisplayname[0].name = this.NewCustomer.company_name + ' ' + this.NewCustomer.title + ' ' + this.NewCustomer.firstname + ' ' + val
      },
      'NewCustomer.lastname': function (val) {
        this.valuesListDisplayname[0].name = this.NewCustomer.company_name + ' ' + this.NewCustomer.title + ' ' + this.NewCustomer.firstname + ' ' + this.NewCustomer.middletname + ' ' + val
        this.valuesListDisplayname[1].name = this.NewCustomer.firstname + ' ' + this.NewCustomer.lastname
        this.valuesListDisplayname[2].name = this.NewCustomer.lastname + ' ' + this.NewCustomer.firstname
        this.valuesListDisplayname[3].name = this.NewCustomer.company_name
      },
    }
   
};

</script>
<style scope="sass">
.eboton i{font-size: 12px;}
.eboton{
  padding: 5px 10px;
  font-size: 14px;
  margin-left:10px;
  color: #fff;
  background-color: #137eff !important;
  border-color: #137eff !important;
}
#btnGroupDrop1{
  height: 26px;
  padding-top: 0px;
}
button.btn.btn-success.btn-new {
  padding: 0px ;
  width: 26px;
  height: 26px;
}


.tabla-transaction {width: 100%}

@media(max-width: 767px){
  .list-group.list-group-flush{
    height: 240px;
  }
}

</style>
